import React from 'react';

import './Checkbox.scss';

interface IProps {
  id: string,
  label: React.ReactNode,
  value: boolean,
  onChange(e: any): void,
  disabled?: boolean,
  className?: string
}

export interface ICheck {
  label: string,
  checked: boolean
}

const Checkbox: React.FC<IProps> = (props) => {
  const classNames = ["Checkbox"];
  if (props.disabled) classNames.push("disabled");
  if (props.className) classNames.push(props.className);
  
  return(
    <div className={classNames.join(" ")}>
      <label htmlFor={props.id} className="check">
        <input disabled={props.disabled} onChange={(e) => { props.onChange(e); }} id={props.id} type="checkbox" checked={props.value ? true : false} />
        <div className="checkSquare"></div>
        <div className="label">{props.label}</div>
      </label>
    </div>
  );
}

export default Checkbox;